import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { StockAgeingPage } from '@/components/StockAgeing/StockAgeingPage'
import { listSearchSchema, withoutListDefaults } from '@/components/common/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live beside the shared list page. */
export const Route = createFileRoute('/_app/operations/stock-ageing/')({
  validateSearch: listSearchSchema,
  component: StockAgeingRoute,
})

function StockAgeingRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <StockAgeingPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
